import { select } from "@/ui/select.js";
import { templateSelect } from "./templateSelect.js";
import { eventEmitter } from "@/utils/event-emitter.js";
import { config } from "@/utils/config.js";
import { appState } from "@/utils/state.js";
import { levelChange } from "@/core/levelChange.js";

export function levelSelect(parent, levelInd = 0) {
  levelChange();
  appState.setState("levelInd", levelInd);

  appState.setState("level", config.levels[appState.getState("levelInd")].text);
  const classes = ["level", "select-level-bar__item"];
  const elem = select({
    parent: parent,
    classes: classes,
    options: config.levels.map((level, i) => ({
      text: level.text,
      index: i,
    })),
    onChange: (e) => eventEmitter.emit("levelChange", e.target.value),
  });
  templateSelect(parent);
  return elem;
}
